import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCloseCircle';
/** Renders an SVG icon. */
const SvgCloseCircle = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M28 16c0-6.627-5.373-12-12-12S4 9.373 4 16s5.373 12 12 12 12-5.373 12-12m2 0c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14"
      />
      <path
        fill="currentColor"
        d="M21.204 9.204a1.126 1.126 0 0 1 1.592 1.592L17.592 16l5.204 5.204.077.086a1.126 1.126 0 0 1-1.583 1.583l-.086-.077L16 17.592l-5.204 5.204a1.126 1.126 0 0 1-1.592-1.592L14.408 16l-5.204-5.204-.077-.086a1.126 1.126 0 0 1 1.583-1.583l.086.077L16 14.408z"
      />
    </svg>
  );
};
SvgCloseCircle.displayName = displayName;
export default SvgCloseCircle;
